import React, { createContext, useContext } from "react";

export const OrganizationContext = createContext(null);

export const OrganizationProvider = ({ children, organization }) => {
  return (
    <OrganizationContext.Provider value={organization}>
      {children}
    </OrganizationContext.Provider>
  );
};

export const useOrganization = () => {
  return useContext(OrganizationContext);
};
